import { encodeRomanNumeralText } from './romanNumerals.js';

export const PROMPT_FONTS = [
  {value:'', label:'Default'},
  {value:'Arial, Helvetica, sans-serif', label:'Arial'},
  {value:'Georgia, serif', label:'Georgia'},
  {value:'"Times New Roman", Times, serif', label:'Times New Roman'},
  {value:'Verdana, Geneva, sans-serif', label:'Verdana'},
  {value:'"Courier New", Courier, monospace', label:'Courier New'},
  {value:'myFirstFont', label:'Custom music font (myFirstFont)'},
  {value:'TheoryRomanNumerals', label:'Roman numerals / figured bass'},
];
export function promptFontFamily(font) {
  return typeof font === 'string' && font.trim() ? font.trim() : undefined;
}
export function formatPromptFontText(text, font) {
  // Convert RN glyphs without removing spaces or line breaks from prose.
  return font === 'TheoryRomanNumerals'
    ? String(text).split(/(\s+)/).map(part => /^\s+$/.test(part) ? part : encodeRomanNumeralText(part)).join('')
    : text;
}
